// utils/enrollmentApi.js
// Centralised API helper for batch-course self-enrollment endpoints.
import apiClient from './apiClient';

const ER = '/enrollment-requests';

// ═══════════════════════ STUDENT ═══════════════════════

export const getCatalogCourses = () =>
  apiClient.get(`${ER}/catalog`);

export const getCatalogCourseDetail = (courseId) =>
  apiClient.get(`${ER}/catalog/${courseId}`);

/**
 * Apply to a batch course.
 * @param {object} payload { courseId, batchId?, notes?, mode? }
 *   `mode: 'request'` files an application for admin approval instead of
 *   opening Razorpay. Omitted / 'pay' keeps the original pay-first behaviour.
 */
export const applyToCourse = (payload) =>
  apiClient.post(`${ER}/apply`, payload);

/** Shorthand for the "Request to Join" button. */
export const requestToJoinCourse = ({ courseId, batchId = null, notes = '' }) =>
  apiClient.post(`${ER}/apply`, { courseId, batchId, notes, mode: 'request' });

export const verifyEnrollmentPayment = (payload) =>
  apiClient.post(`${ER}/verify-payment`, payload);

export const getMyRequests = () =>
  apiClient.get(`${ER}/my-requests`);

// ═══════════════════════ ADMIN ═══════════════════════

export const getEnrollmentRequests = (params = {}) =>
  apiClient.get(`${ER}/admin/list`, { params });

export const getCourseBatchesForEnrollment = (courseId) =>
  apiClient.get(`${ER}/admin/course-batches/${courseId}`);

/** Approve and enrol. `payload.batchId` sets/overrides the batch; `note` is optional. */
export const approveRequest = (id, payload = {}) =>
  apiClient.put(`${ER}/admin/${id}/approve`, payload);

/** Park the decision. `holdReason` is required by the server. */
export const holdRequest = (id, payload = {}) =>
  apiClient.put(`${ER}/admin/${id}/hold`, payload);

/** Decline. `rejectReason` is required by the server. */
export const rejectRequest = (id, payload = {}) =>
  apiClient.put(`${ER}/admin/${id}/reject`, payload);

/**
 * The approval queue for a single batch — used by the Requests tab on the
 * batch page. Returns { batch, direct, unassigned, resolved, counts }.
 */
export const getBatchEnrollmentRequests = (batchId) =>
  apiClient.get(`${ER}/admin/batch/${batchId}`);
